import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';


const SecuritySection = ({ securitySettings, onUpdate }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(securitySettings?.twoFactorEnabled || false);
  const [showQRCode, setShowQRCode] = useState(false);

  const mockActiveSessions = [
    {
      id: 1,
      device: 'Chrome на Windows',
      location: 'Москва, Россия',
      ipAddress: '192.168.1.1',
      lastActive: '2 минуты назад',
      isCurrent: true
    },
    {
      id: 2,
      device: 'Safari на iPhone',
      location: 'Санкт-Петербург, Россия',
      ipAddress: '192.168.1.2',
      lastActive: '2 часа назад',
      isCurrent: false
    },
    {
      id: 3,
      device: 'Firefox на macOS',
      location: 'Казань, Россия',
      ipAddress: '192.168.1.3',
      lastActive: '1 день назад',
      isCurrent: false
    }
  ];

  const handleChangePassword = () => {
    if (newPassword !== confirmPassword) {
      alert('Пароли не совпадают');
      return;
    }
    console.log('Changing password...');
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleToggle2FA = () => {
    if (!twoFactorEnabled) {
      setShowQRCode(true);
    }
    setTwoFactorEnabled(!twoFactorEnabled);
  };

  const handleTerminateSession = (sessionId) => {
    console.log('Terminating session:', sessionId);
  };

  const handleTerminateAllSessions = () => {
    console.log('Terminating all sessions except current');
  };

  return (
    <div className="security-section bg-card rounded-lg p-6 shadow-soft">
      <div className="section-header flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Lock" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Безопасность
          </h2>
          <p className="text-sm text-muted-foreground">
            Управление паролем и активными сеансами
          </p>
        </div>
      </div>
      <div className="security-content space-y-8">
        <div className="password-section">
          <h3 className="text-base font-medium text-foreground mb-4">
            Изменить пароль
          </h3>
          <div className="space-y-4">
            <Input
              label="Текущий пароль"
              type="password"
              placeholder="Введите текущий пароль"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e?.target?.value)}
            />
            <Input
              label="Новый пароль"
              type="password"
              placeholder="Введите новый пароль"
              value={newPassword}
              onChange={(e) => setNewPassword(e?.target?.value)}
              description="Минимум 8 символов, включая цифры и специальные символы"
            />
            <Input
              label="Подтвердите пароль"
              type="password"
              placeholder="Повторите новый пароль"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e?.target?.value)}
            />
            <Button
              variant="default"
              onClick={handleChangePassword}
              iconName="Key"
              iconPosition="left"
            >
              Изменить пароль
            </Button>
          </div>
        </div>

        <div className="two-factor-section pt-8 border-t border-border">
          <div className="flex items-start justify-between mb-4">
            <div>
              <h3 className="text-base font-medium text-foreground mb-1">
                Двухфакторная аутентификация
              </h3>
              <p className="text-sm text-muted-foreground">
                Дополнительный уровень защиты вашего аккаунта
              </p>
            </div>
            <Button
              variant={twoFactorEnabled ? 'destructive' : 'default'}
              size="sm"
              onClick={handleToggle2FA}
            >
              {twoFactorEnabled ? 'Отключить' : 'Включить'}
            </Button>
          </div>

          {showQRCode && !twoFactorEnabled && (
            <div className="qr-code-section p-4 bg-muted/50 rounded-lg">
              <div className="flex flex-col items-center gap-4">
                <div className="w-48 h-48 bg-background rounded-lg flex items-center justify-center border-2 border-border">
                  <Icon name="QrCode" size={120} color="var(--color-foreground)" />
                </div>
                <div className="text-center">
                  <p className="text-sm font-medium text-foreground mb-2">
                    Отсканируйте QR-код в приложении аутентификатора
                  </p>
                  <p className="text-xs text-muted-foreground mb-4">
                    Google Authenticator, Authy или другое приложение
                  </p>
                  <Input
                    type="text"
                    placeholder="Введите код из приложения"
                    className="max-w-xs mx-auto"
                  />
                </div>
              </div>
            </div>
          )}

          {twoFactorEnabled && (
            <div className="two-factor-status p-4 bg-success/10 rounded-lg border border-success/20">
              <div className="flex items-center gap-3">
                <Icon name="ShieldCheck" size={20} color="var(--color-success)" />
                <div>
                  <p className="text-sm font-medium text-foreground">
                    Двухфакторная аутентификация активна
                  </p>
                  <p className="text-xs text-muted-foreground">
                    Ваш аккаунт защищен дополнительным уровнем безопасности
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="sessions-section pt-8 border-t border-border">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-base font-medium text-foreground">
              Активные сеансы
            </h3>
            <Button
              variant="outline"
              size="sm"
              iconName="LogOut"
              iconPosition="left"
              onClick={handleTerminateAllSessions}
            >
              Завершить все
            </Button>
          </div>

          <div className="sessions-list space-y-3">
            {mockActiveSessions?.map((session) => (
              <div
                key={session?.id}
                className="session-item p-4 bg-background rounded-lg border border-border"
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
                      <Icon name="Monitor" size={20} color="var(--color-foreground)" />
                    </div>
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <p className="text-sm font-medium text-foreground">
                          {session?.device}
                        </p>
                        {session?.isCurrent && (
                          <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs rounded-full">
                            Текущий
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-muted-foreground mb-1">
                        {session?.location} • {session?.ipAddress}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        Активность: {session?.lastActive}
                      </p>
                    </div>
                  </div>
                  {!session?.isCurrent && (
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="X"
                      onClick={() => handleTerminateSession(session?.id)}
                    >
                      Завершить
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="security-tips p-4 bg-accent/10 rounded-lg border border-accent/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} color="var(--color-accent)" />
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">
                Советы по безопасности
              </h4>
              <ul className="text-xs text-muted-foreground space-y-1">
                <li>• Используйте уникальный пароль для каждого сервиса</li>
                <li>• Включите двухфакторную аутентификацию для максимальной защиты</li>
                <li>• Регулярно проверяйте активные сеансы и завершайте неизвестные</li>
                <li>• Не делитесь своим паролем и кодами 2FA с другими людьми</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;